import type { BlogPost } from "./blog";

export const BLOG_BIRTHDAY_PART1: BlogPost[] = [
  {
    "slug": "den-rozhdeniya-18-let-restoran-spb",
    "title": "День рождения 18 лет в Петербурге: лучшие идеи для совершеннолетия",
    "metaTitle": "День рождения 18 лет в Петербурге — рестораны и идеи | Паруса",
    "metaDescription": "Где отметить 18-летие в Санкт-Петербурге: рестораны с атмосферой, скидка 20% именинникам, живая музыка и панорамный вид на город.",
    "keywords": "день рождения 18 лет петербург, где отметить 18 лет спб, ресторан совершеннолетие",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/view_night.webp",
    "lead": "18 лет — первый взрослый день рождения. Первый раз, когда хочется не детского торжества, а настоящего праздника: с видом на ночной Петербург, живой музыкой и компанией, которая запомнит этот вечер навсегда. Это рубеж, который требует особого места.",
    "sections": [
      {
        "heading": "Почему 18-летие требует особого места",
        "body": "Совершеннолетие — не просто очередной день рождения. Это переход: из детства во взрослую жизнь, из школы в новый этап. Именно поэтому место имеет значение. Не квартира, не школьный вечер — а ресторан с атмосферой, видом и правильным настроением. В Петербурге для этого есть идеальные условия: панорамные виды, живая музыка, авторская кухня. Ресторан «Паруса на крыше» на 6-м этаже Olympic Plaza — именно такое место. С 2009 года здесь отмечают самые важные вечера.",
        "list": [
          "Первый взрослый праздник — место имеет значение",
          "Панорамный вид на Петербург с 6-го этажа",
          "Живая музыка с четверга по воскресенье",
          "Скидка 20% именинникам — за 7 дней до и после ДР"
        ]
      },
      {
        "heading": "Форматы 18-летия в ресторане",
        "body": "Компания 10–20 человек — оптимальный размер для 18-летия. Банкетный зал или большой стол в основном зале. Живая музыка создаёт атмосферу без специальной программы. Можно заказать именной торт от шеф-кондитера — его принесут с поздравлением. Фотограф на час — хорошая идея для первого взрослого праздника. В «Парусах» вместимость до 300 гостей, но для 18-летия обычно достаточно 15–25 человек и нескольких столов у панорамных окон.",
        "highlight": "Скидка 20% именинникам действует 7 дней до и 7 дней после дня рождения. Плюс десерт от шеф-кондитера в подарок. Телефон для бронирования: +7 (812) 991-10-90."
      },
      {
        "heading": "Меню для 18-летия",
        "body": "Авторская кухня «Парусов» — хорошая основа для праздника. Закуски, горячее, десерты — всё можно согласовать заранее с банкетным менеджером. Если в компании есть вегетарианцы — скажите при бронировании, кухня адаптирует. Бюджет: средний чек около 1 300 ₽/чел, банкетное меню от 2 500 ₽/чел. Для 18-летия популярный выбор — небольшой фуршетный стол плюс горячее.",
        "list": [
          "Банкетное меню от 2 500 ₽/чел — всё включено",
          "Средний чек à la carte: ~1 300 ₽/чел",
          "Торт именинника: под заказ, тема на ваш выбор",
          "Сообщите о диетарных ограничениях при бронировании"
        ]
      },
      {
        "heading": "Как забронировать 18-летие",
        "body": "Звоните за 1–2 недели до даты: +7 (812) 991-10-90. Скажите количество гостей и что это 18-летие — менеджер расскажет о скидке и поможет выбрать формат. Уточните: нужен ли отдельный зал или общий — для небольшой компании обычно берут красивый стол у окна. Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж, Петербург."
      }
    ],
    "cta": { "text": "Забронировать 18-летие", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-25-let-restoran-peterburg",
    "title": "День рождения 25 лет: где отметить в Петербурге стильно и запомнить",
    "metaTitle": "День рождения 25 лет в Петербурге — стильное место | Паруса",
    "metaDescription": "Где отметить 25-летие в Санкт-Петербурге: рестораны с видом, атмосферой и живой музыкой. Скидка 20% именинникам в «Парусах на крыше».",
    "keywords": "день рождения 25 лет петербург, где отметить 25 лет спб, ресторан 25 летие",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_sunset.webp",
    "lead": "25 лет — четверть века. Это не просто цифра: это момент, когда хочется оглянуться назад и с удовольствием посмотреть вперёд. Праздник должен быть таким же — с характером, вкусом и видом, который не забудешь.",
    "sections": [
      {
        "heading": "Что делает 25-летие особенным",
        "body": "В 25 лет у людей уже есть вкусы, предпочтения и круг близких. Праздник хочется не громкий и хаотичный, а осознанный: хорошая еда, правильная атмосфера, люди, которые важны. Ресторан с видом на Петербург с 6-го этажа — это место, которое говорит само за себя. Вам не нужен ведущий и красные шарики. Нужны панорамные окна, авторская кухня и живая музыка — всё это есть в «Парусах на крыше».",
        "list": [
          "Вид 300° на исторический центр Петербурга",
          "Живая музыка — без дополнительной платы",
          "Скидка 20% на счёт именинника",
          "Десерт от шеф-кондитера в подарок"
        ]
      },
      {
        "heading": "Как провести вечер",
        "body": "Для 25-летия идеален формат ужина: стол на 8–15 человек у панорамных окон, несколько часов за разговорами, хорошим вином и авторскими блюдами. Торт приносят в конце с персональным поздравлением — этот момент всегда становится центральным в вечере. Если хотите что-то добавить — фотограф, флористический декор — согласуйте при бронировании.",
        "highlight": "Рейтинг 5,0 на Яндексе, 2 606+ отзывов. «Хорошее место 2026» — звание говорит само за себя. Скидка именинникам: +7 (812) 991-10-90."
      },
      {
        "heading": "Практические детали",
        "body": "Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж. Парковка в комплексе. Живая музыка — с четверга по воскресенье. Бронируйте за 1–2 недели, особенно если выходной. Банкетное меню от 2 500 ₽/чел или обед à la carte (~1 300 ₽/чел). Скидка 20% на счёт именинника действует 7 дней до и после ДР.",
        "list": [
          "Бронировать за 1–2 недели",
          "Живая музыка чт–вс",
          "Парковка в Olympic Plaza",
          "Ул. Марата, 5, 6-й этаж"
        ]
      }
    ],
    "cta": { "text": "Забронировать 25-летие", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-30-let-kak-otmetit-spb",
    "title": "День рождения 30 лет: как отметить в Петербурге, чтобы запомнилось",
    "metaTitle": "День рождения 30 лет в Петербурге — идеи и ресторан | Паруса",
    "metaDescription": "Как отметить 30-летие в Санкт-Петербурге незабываемо. Ресторан с видом, живой музыкой и скидкой 20% именинникам на ул. Марата.",
    "keywords": "день рождения 30 лет петербург, тридцатилетие ресторан спб, отметить 30 лет спб",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "30 лет — рубеж, который в Петербурге принято отмечать красиво. Не квартирная вечеринка — а вечер с характером. Место, которое задаёт тон: панорама, живая музыка, правильная атмосфера. Всё остальное само складывается.",
    "sections": [
      {
        "heading": "Почему 30-летие — особый случай",
        "body": "Тридцатилетие — первый большой юбилей. Многие начинают планировать его за несколько месяцев. Хочется, чтобы вечер был на уровне: не просто ужин, а событие. «Паруса на крыше» отлично справляются с этой задачей: вид на Петербург с 6-го этажа, живая музыка, авторская кухня и возможность арендовать отдельный зал под компанию до 300 человек.",
        "list": [
          "Отдельный зал или стол у окна — на выбор",
          "Вместимость: от 2 до 300 гостей",
          "Скидка 20% на счёт именинника",
          "Работаем с 2009 года, рейтинг 5,0"
        ]
      },
      {
        "heading": "Форматы тридцатилетия",
        "body": "Камерный ужин: 8–12 человек, стол у окна с видом на город. Банкет: 30–80 человек, отдельный зал, ведущий, программа. Фуршет: если гостей много и хотите свободного общения. В «Парусах» банкетный менеджер помогает выбрать формат под ваш запрос и бюджет. Банкетное меню от 2 500 ₽/чел, средний чек à la carte ~1 300 ₽/чел.",
        "highlight": "Скидка 20% на счёт именинника действует 7 дней до и 7 дней после дня рождения. Десерт от шеф-кондитера — в подарок. Бронирование: +7 (812) 991-10-90."
      },
      {
        "heading": "Что важно для 30-летия",
        "body": "Несколько деталей, которые делают разницу: торт под заказ с датой и именем, живая музыка вместо плейлиста, красивый вид из окна на фото. В «Парусах» всё это есть по умолчанию. Если хотите добавить флористику, фотографа или ведущего — уточните при бронировании, рекомендуем проверенных партнёров.",
        "list": [
          "Именной торт от шеф-кондитера",
          "Живая музыка чт–вс включительно",
          "Рекомендуем бронировать за 2–3 недели",
          "Ул. Марата, 5, Olympic Plaza, 6-й этаж"
        ]
      }
    ],
    "cta": { "text": "Забронировать 30-летие", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-40-let-gde-otmetit-spb",
    "title": "День рождения 40 лет в Петербурге: где отметить с размахом",
    "metaTitle": "День рождения 40 лет в Петербурге — ресторан для юбилея | Паруса",
    "metaDescription": "Где отметить 40-летие в Санкт-Петербурге: банкет, ресторан с видом, живая музыка. Скидка 20% именинникам в «Парусах на крыше», ул. Марата 5.",
    "keywords": "день рождения 40 лет петербург, сорокалетие ресторан спб, юбилей 40 лет петербург",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/view_day.webp",
    "lead": "40 лет — это уже не просто день рождения, это первый настоящий юбилей. Место должно соответствовать: солидно, красиво, с атмосферой. Петербург умеет создавать такие вечера — и «Паруса на крыше» занимают в этом первое место.",
    "sections": [
      {
        "heading": "40-летие — первый настоящий юбилей",
        "body": "Сорок лет принято отмечать серьёзно. Гостей обычно много: родственники, друзья, коллеги. Нужен зал, способный вместить 40–80 человек, правильная кухня и атмосфера. «Паруса на крыше» — одно из немногих мест в Петербурге, где можно провести юбилей с панорамным видом на город. Вместимость до 300 гостей. Банкетный менеджер ведёт вечер от бронирования до финала.",
        "list": [
          "Вместимость до 300 гостей",
          "Банкетное меню от 2 500 ₽/чел",
          "Панорамный вид с 6-го этажа",
          "Живая музыка чт–вс"
        ]
      },
      {
        "heading": "Как организовать юбилей 40 лет",
        "body": "Шаг 1: определитесь с количеством гостей. Шаг 2: выберите формат — банкет (за столами) или фуршет (стоя, для общения). Шаг 3: согласуйте меню и программу с менеджером. Шаг 4: добавьте именной торт, флористику, фотографа. В «Парусах» банкетный менеджер координирует всё — вы только приходите на свой праздник. Скидка 20% на счёт именинника, десерт в подарок.",
        "highlight": "Юбилей 40 лет в «Парусах» — это не «снял зал». Это место с историей (работаем с 2009 г.), видом на Петербург и репутацией. Рейтинг 5,0, 2 606 отзывов."
      },
      {
        "heading": "Бюджет и детали",
        "body": "Банкетное меню от 2 500 ₽/чел включает все перемены блюд и безалкогольные напитки. Алкоголь — отдельно или по карте. Торт именинника — по договорённости. Программа вечера с ведущим — по желанию. Бронируйте за 3–4 недели: выходные на юбилеи разбирают заранее. +7 (812) 991-10-90, ул. Марата, 5, 6-й этаж.",
        "list": [
          "Бронируйте за 3–4 недели",
          "Программа с ведущим — опционально",
          "Алкоголь по карте или бутылочно",
          "Торт с датой и фото — под заказ"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 40 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-50-let-yubiley-spb",
    "title": "День рождения 50 лет в Петербурге: юбилей с достоинством",
    "metaTitle": "День рождения 50 лет — юбилей в Петербурге | Паруса на крыше",
    "metaDescription": "Как организовать юбилей 50 лет в Санкт-Петербурге. Ресторан с панорамным видом, банкетным залом и скидкой 20% именинникам. Ул. Марата 5.",
    "keywords": "день рождения 50 лет петербург, юбилей 50 лет ресторан спб, пятидесятилетие ресторан",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/interior.webp",
    "lead": "Пятьдесят лет — это золотой юбилей. Вечер должен быть таким же: не громким и суетным, а достойным. С видом, который захватывает дыхание. С кухней, которой можно гордиться. С атмосферой, которую гости запомнят годами.",
    "sections": [
      {
        "heading": "Юбилей 50 лет: как правильно выбрать место",
        "body": "На пятидесятилетии собираются разные поколения: родители, дети, друзья, коллеги. Место должно устроить всех. Панорамный вид на Петербург нравится без исключения. Авторская кухня — достаточно разнообразна для любых вкусов. Вместимость до 300 гостей позволяет пригласить всех, кого хочется. В «Парусах на крыше» опыт проведения юбилеев с 2009 года — команда знает, что важно.",
        "list": [
          "Подходит для разных поколений гостей",
          "Вместимость до 300 человек",
          "Несколько залов разного размера",
          "Менеджер координирует всё от брони до финала"
        ]
      },
      {
        "heading": "Программа юбилея 50 лет",
        "body": "Классический сценарий: встреча гостей с аперитивом, торжественный ужин с несколькими переменами блюд, поздравления, вынос торта с живой музыкой, вечеринка. В «Парусах» живая музыка — со вт по вс (уточняйте даты), это уже часть атмосферы. Можно добавить ведущего, флористику, слайд-шоу на проекторе. Банкетный менеджер помогает со всем.",
        "highlight": "Скидка 20% на весь счёт именинника — 7 дней до и 7 дней после ДР. Десерт в подарок. Телефон: +7 (812) 991-10-90."
      },
      {
        "heading": "Детали организации",
        "body": "Банкетное меню от 2 500 ₽/чел: закуски, горячее, десерт, безалкогольные напитки. Алкогольная карта — отдельно. Торт с 50 свечами под заказ. Флористика — через партнёров. Фотограф — рекомендуем договориться заранее. Бронируйте за 4–6 недель для юбилея: это ключевые даты, которые расписаны далеко вперёд. +7 (812) 991-10-90, ул. Марата, 5.",
        "list": [
          "Бронируйте за 4–6 недель",
          "Слайд-шоу на проекторе — по запросу",
          "Торт с датой под заказ",
          "Флористика через партнёров"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 50 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-60-let-yubiley-spb",
    "title": "День рождения 60 лет в Петербурге: как отметить юбилей достойно",
    "metaTitle": "Юбилей 60 лет в Петербурге — ресторан с видом | Паруса на крыше",
    "metaDescription": "Где отметить 60-летие в Санкт-Петербурге: ресторан с панорамным видом, живой музыкой. Банкетное меню от 2500 ₽/чел. Скидка 20% именинникам.",
    "keywords": "день рождения 60 лет петербург, юбилей 60 лет ресторан спб, шестидесятилетие",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 7,
    "image": "/photos/view_summer.webp",
    "lead": "60 лет — это не «уже 60». Это «наконец-то 60»: мудрость, опыт, люди рядом. Юбилей в 60 лет должен быть именно таким — не суетным, а достойным. Петербург для этого идеален. «Паруса на крыше» — в частности.",
    "sections": [
      {
        "heading": "Юбилей 60 лет: что ценят гости",
        "body": "На шестидесятилетии собираются близкие из разных поколений. Им важно: комфорт, красивое место, хорошая еда. Не громкая вечеринка — тихое достоинство. Панорамный вид на Петербург создаёт именно ту торжественность, которая нужна. Живая музыка добавляет тепло без суеты. Команда «Парусов» знает, как сделать такой вечер: бережно, без лишних слов, с правильным ритмом.",
        "list": [
          "Комфортные залы без ступенек и тесноты",
          "Вид на центр Петербурга — праздничный фон",
          "Живая музыка — фоном, не гулко",
          "Персональное поздравление от команды"
        ]
      },
      {
        "heading": "Как организовать 60-летие в Петербурге",
        "body": "Позвоните заранее: +7 (812) 991-10-90. Скажите дату, количество гостей и что это юбилей 60 лет. Менеджер предложит залы, формат и меню. Типичный выбор: банкет 30–60 человек в отдельном зале, ужин с несколькими переменами, торт с 60 свечами, живая музыка. Скидка 20% на счёт именинника. Банкетное меню от 2 500 ₽/чел.",
        "highlight": "«Паруса на крыше» работают с 2009 года. Рейтинг 5,0 на Яндексе. «Хорошее место 2026». Это не случайность — это годы работы для таких вечеров."
      },
      {
        "heading": "Что включить в программу",
        "body": "Программа юбилея 60 лет: встреча с шампанским, торжественный ужин, поздравления гостей, живая музыка, вынос торта. Можно добавить слайд-шоу с фотографиями из жизни юбиляра — это всегда трогает. Фотограф — рекомендуем договориться самостоятельно. Цветочное оформление — через партнёров ресторана. Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж.",
        "list": [
          "Слайд-шоу на проекторе — трогательный элемент",
          "Шампанское на встречу гостей",
          "Торт с 60 свечами под заказ",
          "Бронируйте за 4–6 недель"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 60 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-70-let-yubiley-spb",
    "title": "День рождения 70 лет в Петербурге: торжество с классом",
    "metaTitle": "Юбилей 70 лет в Петербурге — ресторан для торжества | Паруса",
    "metaDescription": "Как отметить 70-летие в Санкт-Петербурге: ресторан с комфортом, панорамным видом и хорошей кухней. Скидка 20% именинникам. Банкетное меню.",
    "keywords": "день рождения 70 лет петербург, юбилей 70 лет ресторан спб, семидесятилетие банкет",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "70 лет — это праздник мудрости. Гостей много, они из разных поколений, и всем важно: красиво, вкусно и комфортно. «Паруса на крыше» созданы именно для таких вечеров: достойное место с видом на Петербург.",
    "sections": [
      {
        "heading": "Особенности юбилея 70 лет",
        "body": "На семидесятилетии важно думать о комфорте гостей всех возрастов. Хороший лифт — есть (Olympic Plaza). Удобные кресла и столы — есть. Хорошее освещение — есть. Тихая живая музыка — есть. Комфортная кухня без экспериментов — есть. Всё это в «Парусах на крыше» продумано годами.",
        "list": [
          "Доступность: лифт, удобный вход, Olympic Plaza",
          "Разнообразное меню для всех вкусов",
          "Отдельные залы — тишина и уединённость",
          "Живая музыка — фоном, без громкой акустики"
        ]
      },
      {
        "heading": "Организация торжества",
        "body": "Звоните заблаговременно — за 4–8 недель: +7 (812) 991-10-90. Типичный сценарий: 40–80 гостей, банкет в отдельном зале, несколько перемен блюд, поздравления, торт. Можно добавить концертный номер — живую музыку, вокал, романсы под гитару. Всё согласовывается с менеджером. Скидка 20% на счёт именинника.",
        "highlight": "За 17 лет работы «Паруса» провели тысячи юбилеев. Рейтинг 5,0. Опыт чувствуется в каждой детали — от подачи блюд до правильного освещения зала."
      },
      {
        "heading": "Что ценится на юбилее 70 лет",
        "body": "Гости 70-летия ценят: правильную температуру в зале, хорошую слышимость речей, вкусную классическую кухню, личное внимание от персонала. В «Парусах» сервис выстроен так, чтобы каждый гость чувствовал себя важным. Это то, за что нас выбирают для семейных торжеств. Адрес: ул. Марата, 5, 6-й этаж.",
        "list": [
          "Комфортная температура залов",
          "Персональное внимание к каждому гостю",
          "Классическая кухня — проверенные блюда",
          "Уважительный, деликатный сервис"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 70 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "kamernyy-prazdnik-dr-restoran-spb",
    "title": "Камерный день рождения в ресторане Петербурга: только близкие",
    "metaTitle": "Камерный день рождения в ресторане СПб | Паруса на крыше",
    "metaDescription": "Камерный праздник для близких в Петербурге: небольшой стол, вид на город, живая музыка. Скидка 20% именинникам. Ул. Марата 5, Olympic Plaza.",
    "keywords": "камерный день рождения ресторан спб, маленький праздник ресторан петербург, день рождения только близкие",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_clouds.webp",
    "lead": "Иногда лучший день рождения — не большая вечеринка, а камерный ужин с теми, кто действительно важен. Три-пять человек, хорошее вино, вид на Петербург и разговоры, которые остаются в памяти надолго.",
    "sections": [
      {
        "heading": "Почему камерный ужин — лучший выбор",
        "body": "С возрастом меняется понимание праздника. Не количество гостей, а их качество. Не громкая музыка, а живой разговор. Не большой зал, а красивый стол у окна. «Паруса на крыше» идеально подходят для камерного дня рождения: стол на 2–8 человек у панорамных окон с видом на Казанский собор, авторская кухня, живая музыка фоном — и никакой суеты.",
        "list": [
          "Стол у окна с видом — главный элемент",
          "Небольшая компания: 2–8 человек",
          "Живая музыка — мягкий фон для разговора",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Как забронировать камерный вечер",
        "body": "Позвоните за 3–5 дней: +7 (812) 991-10-90. Скажите «хочу стол у окна для 4 человек, день рождения». Попросите стол с лучшим видом — в хорошем ресторане это выполнимо. Сообщите о дне рождения при бронировании — принесут десерт с поздравлением. Если хотите — закажите отдельный торт. Скидка 20% на счёт именинника действует автоматически при предъявлении паспорта.",
        "highlight": "Камерный вечер в «Парусах» — это ужин с видом на город и без лишнего шума. Именно это нужно, когда хочется по-настоящему отметить, а не просто собраться."
      },
      {
        "heading": "Что заказать на камерный ужин",
        "body": "Для камерного вечера хорошо работает: устрицы на старт, основное блюдо под вкус именинника, бутылка хорошего вина, торт или тирамису на финал. Сомелье поможет с выбором вина. Официант — расскажет о сезонных позициях. Средний чек ~1 300 ₽/чел. Всё остальное — приходите и наслаждайтесь видом.",
        "list": [
          "Устрицы или карпаччо — хороший старт",
          "Вино к ужину — спросите сомелье",
          "Торт под заказ или десерт от шеф-кондитера",
          "Средний чек: ~1 300 ₽/чел"
        ]
      }
    ],
    "cta": { "text": "Забронировать камерный ужин", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "vecherinka-den-rozhdeniya-restoran-spb",
    "title": "Вечеринка на день рождения в ресторане Петербурга: большая компания",
    "metaTitle": "Вечеринка день рождения в ресторане СПб | Паруса на крыше",
    "metaDescription": "Вечеринка на день рождения в Петербурге: большой зал, живая музыка, авторская кухня и скидка 20% именинникам. Вместимость до 300 гостей.",
    "keywords": "вечеринка день рождения ресторан петербург, большой день рождения спб ресторан, праздник с компанией петербург",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Когда хочется настоящую вечеринку — громкую, яркую, с большой компанией — нужен ресторан, который это умеет. Не маленькое кафе, а пространство, которое «раскрывается» при большом количестве гостей и живой музыке.",
    "sections": [
      {
        "heading": "Большая вечеринка: что важно",
        "body": "Для вечеринки на 30–100+ человек нужно: вместительное пространство, хорошая акустика, возможность для танцев или свободного общения, живая музыка или ди-джей, правильный сервис. «Паруса на крыше» вмещают до 300 гостей и имеют несколько залов для разных форматов. Живая музыка — стандартная часть вечера с четверга по воскресенье.",
        "list": [
          "Вместимость до 300 гостей",
          "Несколько залов: под любой размер",
          "Живая музыка — в расписании",
          "Банкетное меню от 2 500 ₽/чел"
        ]
      },
      {
        "heading": "Как организовать вечеринку",
        "body": "Позвоните за 3–4 недели: +7 (812) 991-10-90. Назовите количество гостей, дату и формат. Банкетный менеджер предложит зал и меню. Обычная структура вечеринки: встреча с аперитивом, ужин, торт, вечеринка с музыкой. Если нужен ведущий — можем порекомендовать. Скидка 20% на счёт именинника.",
        "highlight": "Вечеринка в «Парусах» — это виды Петербурга как декорация. Никакие шарики не нужны, когда за окном ночной город и купола. Это работает само."
      },
      {
        "heading": "Фуршет или банкет",
        "body": "Для большой вечеринки два формата. Банкет: все сидят за столами, блюда подаются по-ресторанному, атмосфера торжественная. Фуршет: все стоят или ходят, общение свободнее, обычно дешевле на 20–30%. Для вечеринки-«движа» — фуршет. Для торжественного юбилея — банкет. В «Парусах» возможны оба формата и их комбинация.",
        "list": [
          "Банкет: торжественно, все за столами",
          "Фуршет: свободное общение, дешевле",
          "Комбинированный: ужин + фуршет-финал",
          "Согласуйте формат с менеджером"
        ]
      }
    ],
    "cta": { "text": "Забронировать вечеринку", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "uzhin-den-rozhdeniya-dvoe-peterburg",
    "title": "Ужин на день рождения вдвоём в Петербурге: романтика и только вы",
    "metaTitle": "Ужин на день рождения вдвоём — Петербург | Паруса на крыше",
    "metaDescription": "Романтический ужин на день рождения вдвоём в Петербурге: стол с видом, живая музыка, десерт в подарок. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "ужин день рождения вдвоём петербург, романтический день рождения спб, день рождения для двоих ресторан",
    "date": "2026-06-17",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_sunset.webp",
    "lead": "Иногда самый лучший день рождения — вдвоём. Один стол, два бокала, вид на Петербург и человек, который важнее всех гостей на свете. Остальное — детали.",
    "sections": [
      {
        "heading": "Ужин для двоих: что делает его особенным",
        "body": "Ужин вдвоём на день рождения требует одного — правильного места. Не просто ресторан, а место, где есть вид, тишина и ощущение особенности. Стол у панорамного окна в «Парусах на крыше» — именно это. Ночной Петербург за стеклом, живая музыка фоном, десерт с поздравлением в конце. Это трудно переиграть.",
        "list": [
          "Стол у панорамного окна — под запрос",
          "Вид на ночной Петербург — бесплатный декор",
          "Живая музыка — без доплаты",
          "Десерт именинникам — в подарок"
        ]
      },
      {
        "heading": "Как забронировать стол для двоих",
        "body": "Позвоните: +7 (812) 991-10-90. Скажите «стол для двоих у окна, день рождения». Попросите самый красивый вид — выполнимо при заблаговременном бронировании. Скажите имя именинника — персональное поздравление от ресторана добавляет тепло. Скидка 20% на счёт именинника действует автоматически.",
        "highlight": "Скидка 20%, десерт в подарок, вид на Петербург — и это всё не требует дополнительных усилий. Просто забронируйте и приходите."
      },
      {
        "heading": "Что заказать на ужин для двоих",
        "body": "Рекомендуем: шампанское или игристое на старт, лёгкие закуски (тартар, карпаччо), основное блюдо под вкус именинника, десерт — или заказать торт под заказ заранее. Сомелье поможет выбрать вино. Официант принесёт меню и расскажет о сезонных блюдах. Весь вечер — без лишних людей и шума, только вы двое и Петербург за окном.",
        "list": [
          "Шампанское на старт — классика",
          "Тартар или устрицы — для особого тона",
          "Торт на двоих под заказ",
          "Вино — спросите сомелье"
        ]
      }
    ],
    "cta": { "text": "Забронировать романтический ужин", "href": "/romanticheskiy-uzhin" }
  },
  {
    "slug": "den-rozhdeniya-5-chelovek-restoran-spb",
    "title": "День рождения 5 человек в ресторане Петербурга: маленький, но запоминающийся",
    "metaTitle": "День рождения на 5 человек в ресторане СПб | Паруса на крыше",
    "metaDescription": "День рождения на 5 человек в Петербурге: стол с видом, авторская кухня, живая музыка. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "день рождения 5 человек ресторан спб, небольшой день рождения петербург, стол для пяти ресторан",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/food.webp",
    "lead": "Пять человек — это лучшее число для дня рождения. Все слышат друг друга. Никто не теряется. Разговор течёт. Именно такой праздник остаётся в памяти дольше всего.",
    "sections": [
      {
        "heading": "Почему пять — идеальное число",
        "body": "В компании из пяти человек каждый важен. Нет разделения на «тех, кто у стола» и «тех, кто у бара». Все за одним столом, все участвуют. Для такого формата в «Парусах» идеально подходит круглый или овальный стол у панорамного окна. Вид на Петербург, живая музыка, хорошее вино — вечер создаётся сам.",
        "list": [
          "Круглый стол на 5–6 человек у окна",
          "Все участвуют в разговоре",
          "Скидка 20% именинникам",
          "Десерт с поздравлением — в подарок"
        ]
      },
      {
        "heading": "Что заказать на пятерых",
        "body": "На пятерых хорошо работает формат «несколько блюд на стол»: закуски на выбор для всех, горячее каждому, один общий торт или десерт именинника в подарок. Средний чек ~1 300 ₽/чел — за вечер с видом на Петербург это отличное соотношение. Можно добавить бутылку вина на столик — это делает вечер уютнее.",
        "highlight": "Маленький праздник — не значит скромный. Пять человек у окна в «Парусах» + панорама Петербурга = вечер, о котором говорят потом."
      },
      {
        "heading": "Как забронировать",
        "body": "Звоните за 2–4 дня: +7 (812) 991-10-90. Попросите стол для пяти у окна. Скажите о дне рождения. Всё остальное расскажут. Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж.",
        "list": [
          "Бронируйте за 2–4 дня",
          "Просите стол у окна",
          "Укажите день рождения при брони",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать стол на пятерых", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-25-chelovek-restoran-spb",
    "title": "День рождения на 25 человек в Петербурге: как организовать",
    "metaTitle": "День рождения на 25 человек в ресторане СПб | Паруса на крыше",
    "metaDescription": "Как организовать день рождения на 25 человек в Санкт-Петербурге: зал, меню, живая музыка. Банкетное меню от 2500 ₽/чел. Скидка 20% именинникам.",
    "keywords": "день рождения 25 человек ресторан петербург, банкет 25 человек спб, праздник на 25 гостей",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "25 человек — это уже не «просто посидеть», но ещё не «большой банкет». Идеальный размер для праздника с характером: достаточно людей для веселья, но всё ещё достаточно камерно, чтобы пообщаться со всеми.",
    "sections": [
      {
        "heading": "Особенности банкета на 25 гостей",
        "body": "Для 25 человек обычно берут отдельный зал или закрытую часть ресторана. Это даёт приватность и возможность сделать программу: поздравления, тосты, торт. В «Парусах на крыше» есть залы для этого размера с видом на Петербург. Банкетный менеджер поможет с рассадкой и меню.",
        "list": [
          "Отдельный зал — для 25 гостей",
          "Рассадка за одним или несколькими столами",
          "Программа вечера по желанию",
          "Банкетное меню от 2 500 ₽/чел"
        ]
      },
      {
        "heading": "Организация вечера",
        "body": "Типичная структура: встреча с аперитивом, торжественный ужин (2–3 смены блюд), поздравления, торт, вечеринка. Живая музыка в «Парусах» — с четверга по воскресенье, без доплаты. Скидка 20% на счёт именинника. Бронируйте за 2–3 недели.",
        "highlight": "25 гостей — это та компания, когда каждый чувствует праздник, но вечер не превращается в хаос. В «Парусах» это наш любимый формат."
      },
      {
        "heading": "Бюджет и логистика",
        "body": "Банкетное меню от 2 500 ₽/чел × 25 = от 62 500 ₽ за банкет. Алкоголь — отдельно. Торт — под заказ. Флористика — по желанию. Всё согласовывается с менеджером. Адрес: ул. Марата, 5, Olympic Plaza, 6-й этаж. Парковка в комплексе.",
        "list": [
          "Бронируйте за 2–3 недели",
          "Торт под заказ",
          "Алкоголь по карте или своё с посудным сбором",
          "Уточните о флористике при бронировании"
        ]
      }
    ],
    "cta": { "text": "Забронировать банкет на 25", "href": "/banket" }
  },
  {
    "slug": "den-rozhdeniya-50-chelovek-restoran-spb",
    "title": "День рождения на 50 человек в Петербурге: большой банкет с видом",
    "metaTitle": "День рождения на 50 человек — банкет в СПб | Паруса на крыше",
    "metaDescription": "Банкет на 50 человек в Санкт-Петербурге: зал с панорамным видом, живая музыка, банкетное меню от 2500 ₽/чел. Скидка 20% именинникам.",
    "keywords": "день рождения 50 человек ресторан петербург, банкет 50 человек спб, юбилей 50 гостей",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "50 гостей — это серьёзный праздник. Нужен зал, который их вместит, кухня, которая накормит, и атмосфера, которая объединит всех. В «Парусах на крыше» всё это есть.",
    "sections": [
      {
        "heading": "Организация банкета на 50 человек",
        "body": "Для пятидесяти гостей нужен отдельный зал. В «Парусах» есть несколько залов с видом на Петербург, вмещающих 40–120 человек. Рассадка продумывается с менеджером: стол-«подкова», несколько столов, ресторанный формат. Живая музыка — фоновая или с выходами на площадку. Банкетное меню от 2 500 ₽/чел.",
        "list": [
          "Залы на 40–120 гостей",
          "Несколько вариантов рассадки",
          "Живая музыка включена",
          "Банкетное меню от 2 500 ₽/чел"
        ]
      },
      {
        "heading": "Программа банкета",
        "body": "Стандартная программа: встреча с аперитивом, торжественный ужин, поздравления и тосты, выход торта с живой музыкой, вечеринка. Можно добавить ведущего, ди-джея после живой музыки, слайд-шоу. Всё согласовывается при бронировании. Скидка 20% на счёт именинника, десерт в подарок.",
        "highlight": "50 гостей в «Парусах» — это одновременно и праздник, и впечатление. Панорама Петербурга с 6-го этажа — декорация, которая заменяет любой декор."
      },
      {
        "heading": "Стоимость и бронирование",
        "body": "Банкет на 50 человек: от 2 500 ₽/чел × 50 = от 125 000 ₽. Алкоголь — по карте или отдельным пакетом. Торт — под заказ. Программа с ведущим — от партнёров. Бронируйте за 3–5 недель: эти залы расписаны наперёд. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 3–5 недель",
          "Алкогольный пакет — по запросу",
          "Ведущий и ди-джей — через партнёров",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать банкет на 50", "href": "/banket" }
  },
  {
    "slug": "den-rozhdeniya-100-chelovek-banket-spb",
    "title": "День рождения на 100 человек в Петербурге: крупный банкет",
    "metaTitle": "День рождения на 100 человек — банкет СПб | Паруса на крыше",
    "metaDescription": "Банкет на 100 человек в Санкт-Петербурге с панорамным видом. Вместимость до 300 гостей, живая музыка. Банкетное меню от 2500 ₽/чел.",
    "keywords": "день рождения 100 человек ресторан спб, крупный банкет петербург, банкет 100 гостей",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "100 гостей — это масштаб, который требует ресторана с соответствующими возможностями. Большой зал, профессиональная кухня, выверенный сервис. «Паруса на крыше» вмещают до 300 гостей — это не предел возможностей, это свободное пространство.",
    "sections": [
      {
        "heading": "Что нужно для банкета на 100 человек",
        "body": "Зал вместимостью 100+ человек. Кухня, способная обслужить всех одновременно. Достаточно персонала (в «Парусах» норма: 1 официант на 10–12 гостей). Качественное звуковое оборудование. Место для торта и поздравлений. В «Парусах на крыше» всё это предусмотрено. Банкетный менеджер координирует каждый аспект.",
        "list": [
          "Зал до 300 гостей",
          "Профессиональная кухня",
          "1 официант на 10–12 гостей",
          "Звуковое оборудование для речей"
        ]
      },
      {
        "heading": "Логистика большого банкета",
        "body": "Для 100 гостей важно: заблаговременное бронирование (за 6–8 недель), чёткий тайминг подачи блюд, продуманная рассадка, план вечера. Банкетный менеджер «Парусов» составляет поминутный план: встреча, аперитив, горячие закуски, основное, торт, вечеринка. Это снимает с вас 80% организационной нагрузки.",
        "highlight": "100 гостей в «Парусах» — опыт, который отработан годами. Банкеты этого масштаба мы проводим регулярно. Рейтинг 5,0 — это отзывы именно таких вечеров."
      },
      {
        "heading": "Стоимость банкета на 100 человек",
        "body": "Банкетное меню от 2 500 ₽/чел × 100 = от 250 000 ₽. Это включает все перемены блюд и безалкогольные напитки. Алкоголь — отдельно (пакет или по карте). Ведущий, ди-джей, фотограф — через партнёров. Торт на 100 человек — заказывается за 2–3 недели. +7 (812) 991-10-90.",
        "list": [
          "От 250 000 ₽ на еду (без алкоголя)",
          "Алкогольный пакет — по запросу",
          "Бронируйте за 6–8 недель",
          "Торт под заказ за 2–3 недели"
        ]
      }
    ],
    "cta": { "text": "Обсудить банкет на 100 гостей", "href": "/banket" }
  },
  {
    "slug": "den-rozhdeniya-zimoy-restoran-spb",
    "title": "День рождения зимой в Петербурге: идеи и лучшие места",
    "metaTitle": "День рождения зимой в Петербурге — рестораны | Паруса на крыше",
    "metaDescription": "Где отметить день рождения зимой в Санкт-Петербурге: рестораны с уютом и видом. Скидка 20% именинникам. Живая музыка. Ул. Марата 5.",
    "keywords": "день рождения зимой петербург, зимний день рождения ресторан спб, праздник зима петербург",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_night.webp",
    "lead": "Зимний Петербург особенный. Белые снежные вечера, мягкий свет фонарей, ощущение камерности. День рождения зимой в этом городе — это не минус погода, это особый характер праздника.",
    "sections": [
      {
        "heading": "Почему зимой в ресторане — лучше",
        "body": "Зимой хочется тепла, уюта, хорошей компании за столом. Именно это даёт ресторан. Панорамный вид на зимний Петербург с 6-го этажа «Парусов» — особенная картина: снег на крышах, огни города, белые ночи уступили место белым морозным вечерам. Живая музыка делает атмосферу завершённой. Средний чек ~1 300 ₽/чел.",
        "list": [
          "Зимний вид на Петербург — особенная атмосфера",
          "Тепло и уют — внутри всегда комфортно",
          "Живая музыка — с четверга по воскресенье",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Декабрь, январь, февраль — все месяцы хороши",
        "body": "Декабрь: предновогодняя атмосфера, праздничный декор, хорошее настроение у всех. Январь: тихий месяц, меньше людей, можно выбить лучший стол. Февраль: особенно если 14-е — романтика удваивается. В «Парусах» зимой всегда уютно: правильная температура в залах, горячий чай и кофе, зимнее меню с сезонными блюдами.",
        "highlight": "Зимний день рождения в «Парусах» — это виды снежного Петербурга и тепло ресторана. Два крайности, которые создают идеальное ощущение."
      },
      {
        "heading": "Что особенного зимой",
        "body": "Зимнее меню: дичь, грибные блюда, согревающие супы, глинтвейн и горячие напитки. Флористика: живые ели и гирлянды создают праздничность без доп. затрат. Закат рано — зимний вечер начинается в 15:00, что идеально для тех, кто хочет видеть сумерки над городом. Бронируйте заранее: зима — популярный сезон для праздников.",
        "list": [
          "Зимнее меню: дичь, грибы, согревающие блюда",
          "Глинтвейн и горячие напитки",
          "Ранние сумерки — красивее закат",
          "Декабрь — особая атмосфера"
        ]
      }
    ],
    "cta": { "text": "Забронировать зимний день рождения", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-vesnoy-restoran-peterburg",
    "title": "День рождения весной в Петербурге: первые теплые дни",
    "metaTitle": "День рождения весной в Петербурге | Паруса на крыше",
    "metaDescription": "Где отметить день рождения весной в Санкт-Петербурге. Открытие террасы, весенние блюда, вид на оживающий город. Скидка 20% именинникам.",
    "keywords": "день рождения весной петербург, весенний праздник ресторан спб, день рождения апрель петербург",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_summer.webp",
    "lead": "Весенний Петербург — это воскрешение. После долгой зимы первые тёплые дни, первые зелёные листья, первые вечера на свежем воздухе. День рождения весной в этом городе — лёгкость и предвкушение.",
    "sections": [
      {
        "heading": "Весенний Петербург — особое место для праздника",
        "body": "Март–май в Петербурге — это постепенное пробуждение. Корюшка в апреле — главный весенний деликатес. Открытие террас — первые ужины под открытым небом. В «Парусах на крыше» терраса открывается в мае — и это становится событием. Панорамный вид на оживающий город, первое тепло, весеннее меню — идеальный фон для дня рождения.",
        "list": [
          "Корюшка в сезон (апрель-май) — петербургская традиция",
          "Терраса открывается в мае",
          "Весенний вид: первая зелень над Петербургом",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что особенного весной",
        "body": "Весеннее меню в «Парусах»: спаржа, черемша, свежие травы, корюшка. Это те блюда, которые есть только несколько недель в году — и именно в них вкус весеннего Петербурга. Терраса с видом на крыши города — лучший столик весной. День рождения с корюшкой на террасе — это петербургская классика.",
        "highlight": "«Паруса на крыше» открывают terrас в мае. Первый весенний ужин под открытым небом с видом на Петербург — один из лучших подарков на день рождения."
      },
      {
        "heading": "Праздник весной: что учесть",
        "body": "В мае бронируйте заранее — открытие террасы очень популярно. В марте-апреле мест больше, погода непредсказуема — но панорамные окна дают тот же вид. Весеннее меню доступно с апреля. Живая музыка — с четверга по воскресенье. Бронируйте: +7 (812) 991-10-90.",
        "list": [
          "Май: бронируйте за 2–3 недели",
          "Март-апрель: спокойнее, но тоже красиво",
          "Весеннее меню — с апреля",
          "Терраса — с мая"
        ]
      }
    ],
    "cta": { "text": "Забронировать весенний праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-letom-restoran-spb",
    "title": "День рождения летом в Петербурге: белые ночи и терраса",
    "metaTitle": "День рождения летом в Петербурге — белые ночи | Паруса",
    "metaDescription": "Где отметить день рождения летом в Санкт-Петербурге: терраса, белые ночи, панорамный вид. Скидка 20% именинникам. Живая музыка.",
    "keywords": "день рождения летом петербург, белые ночи день рождения, праздник лето спб терраса",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/terrace.webp",
    "lead": "Лето в Петербурге — это белые ночи. Когда в полночь всё ещё светло, когда закат не заканчивается до двух ночи, когда город живёт иначе. День рождения летом здесь — это не просто праздник, это ощущение, которое трудно описать словами.",
    "sections": [
      {
        "heading": "Белые ночи и день рождения",
        "body": "Июнь и июль в Петербурге — сезон белых ночей. Терраса «Парусов на крыше» в это время — самое популярное место города. С 6-го этажа Olympic Plaza вид на освещённый закатным солнцем центр Петербурга даже в 22:00 — это нечто. День рождения на террасе в белую ночь — опыт, который не забывается.",
        "list": [
          "Белые ночи: июнь-июль",
          "Терраса открыта в хорошую погоду",
          "Вид на вечерний Петербург до полуночи",
          "Живая музыка на террасе"
        ]
      },
      {
        "heading": "Летнее меню",
        "body": "Лето в «Парусах»: гаспачо и холодные супы, сезонные salаты, рыба и морепродукты, лёгкие десерты, сорбеты. Всё это сочетается с видом на летний Петербург. Летние коктейли и холодные вина дополняют картину. Скидка 20% именинникам, десерт в подарок.",
        "highlight": "Белая ночь + терраса + живая музыка + именной торт = день рождения, который гости вспомнят через 10 лет. Это не преувеличение."
      },
      {
        "heading": "Как планировать летний праздник",
        "body": "Летом «Паруса» очень загружены. Бронируйте за 2–4 недели минимум. Терраса — под запрос, зависит от погоды. Если погода подводит — есть план Б: панорамные окна внутри с тем же видом. Звоните: +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 2–4 недели",
          "Терраса — по погоде",
          "План Б: окна с тем же видом",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать летний праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-osenyu-restoran-peterburg",
    "title": "День рождения осенью в Петербурге: золото и уют",
    "metaTitle": "День рождения осенью в Петербурге | Паруса на крыше",
    "metaDescription": "Где отметить день рождения осенью в Санкт-Петербурге. Осенние блюда, уютная атмосфера, панорамный вид. Скидка 20% именинникам.",
    "keywords": "день рождения осенью петербург, осенний праздник ресторан спб, день рождения сентябрь октябрь",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "Осень в Петербурге — это золото листьев, влажный воздух и особое настроение уюта. Вечер в ресторане с видом на осенний город — именно то, что нужно для дня рождения в этот сезон.",
    "sections": [
      {
        "heading": "Осенний Петербург: особенная красота",
        "body": "Сентябрь и октябрь — золотое время Петербурга. Листья на деревьях вдоль Марата, купола в дымке, набережные с первым туманом. С 6-го этажа «Парусов» этот вид особенный: слой за слоем крыши, и где-то там — золото садов. Для дня рождения — идеальная декорация без всякого декора.",
        "list": [
          "Золотая осень в видах на Петербург",
          "Уютная атмосфера внутри",
          "Осенние грибные блюда",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Осеннее меню",
        "body": "Осень — сезон белых грибов, дичи, тыквы, клюквы. В «Парусах» осеннее меню — одно из лучших в году: крем-суп из белых грибов, утка с ягодным соусом, тыквенный чизкейк. Это то, ради чего стоит дождаться осени. День рождения в октябре — возможность попробовать всё это.",
        "highlight": "Грибной сезон в «Парусах» — август-октябрь. Белые грибы, лисички, маслята — в блюдах от шефа. Это один из главных аргументов для осеннего дня рождения."
      },
      {
        "heading": "Почему осень — лучший сезон",
        "body": "Ноябрь — уже совсем осень, темнеет рано, огни города появляются в 16:00. Вечерний вид с 6-го этажа ноябрём — особенный: много света внизу, мало его вверху. Уют ресторана на контрасте с улицей создаёт ощущение укрытости и тепла. День рождения в ноябре в «Парусах» — когда снаружи серо, а внутри светло и хорошо.",
        "list": [
          "Сентябрь-октябрь: золотая осень",
          "Ноябрь: уют на контрасте с улицей",
          "Грибное меню — сентябрь-октябрь",
          "Ранние сумерки — ранний вечерний вид"
        ]
      }
    ],
    "cta": { "text": "Забронировать осенний праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-yanvar-restoran-spb",
    "title": "День рождения в январе в Петербурге: праздник после праздников",
    "metaTitle": "День рождения в январе в Петербурге | Паруса на крыше",
    "metaDescription": "Где отметить день рождения в январе в Санкт-Петербурге после новогодних праздников. Скидка 20% именинникам, живая музыка, панорама.",
    "keywords": "день рождения январь петербург, праздник после нового года спб, день рождения январе ресторан",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Январский день рождения — особый. Все устали от новогодних праздников, гости «отдыхают от праздников». Но ваш день рождения — это ваш день. И он заслуживает отдельного внимания.",
    "sections": [
      {
        "heading": "Январь: тихий месяц для особенного праздника",
        "body": "В январе рестораны немного тише, чем в декабре. Можно выбрать лучший стол, меньше ждать бронирования, получить больше внимания от персонала. Зимний Петербург в январе — красивый и спокойный. Для дня рождения это хорошо: вы не соревнуетесь с новогодней суетой, вы просто празднуете.",
        "list": [
          "Меньше конкуренции за лучший стол",
          "Больше внимания от персонала",
          "Зимний тихий Петербург за окном",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что предложить гостям в январе",
        "body": "Гости немного «в режиме отдыха» после праздников — это нормально. Предложите им что-то особенное: ужин в «Парусах» с видом на зимний Петербург. Живая музыка в четверг–воскресенье. Авторская кухня с зимним меню. Десерт именинника в подарок. Это ненавязчивый, тёплый праздник.",
        "highlight": "Январский день рождения в «Парусах» — без суеты, без конкуренции с другими праздниками, только ваш вечер и город за окном."
      },
      {
        "heading": "Как организовать",
        "body": "Бронируйте за 5–7 дней в январе — это не высокий сезон. Попросите стол у окна с зимним видом. Скажите о дне рождения. Всё остальное — приходите и наслаждайтесь. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 5–7 дней",
          "Просите стол у окна",
          "Скажите о дне рождения",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать январский праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-fevral-restoran-peterburg",
    "title": "День рождения в феврале в Петербурге: февраль — это особо",
    "metaTitle": "День рождения в феврале в Петербурге | Паруса на крыше",
    "metaDescription": "Где отметить день рождения в феврале в Санкт-Петербурге. Скидка 20% именинникам. Живая музыка. Панорамный вид на зимний Петербург.",
    "keywords": "день рождения февраль петербург, праздник февраль ресторан спб, день рождения зима февраль",
    "date": "2026-06-18",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_night.webp",
    "lead": "Февраль в Петербурге — месяц крайностей. Последний зимний месяц, предвкушение весны. 23 февраля, 14 февраля, масленица. Если ваш день рождения в феврале — вы в хорошей компании с праздниками.",
    "sections": [
      {
        "heading": "Февраль: праздник на празднике",
        "body": "Февраль густо насыщен праздниками. День влюблённых 14-го, 23-е, масленица. Если ваш день рождения в этом месяце — его легко «потерять» в общем шуме. Поэтому важно выбрать место, которое создаёт ощущение вашего личного праздника. «Паруса на крыше» справляются с этим: скидка 20% именинникам, именной торт, живая музыка — и вы главный герой вечера.",
        "list": [
          "Февраль — месяц праздников, ваш особый",
          "Скидка 20% именинникам",
          "Именной торт и поздравление",
          "14 февраля — двойной праздник"
        ]
      },
      {
        "heading": "14 февраля — два праздника в одном",
        "body": "Если ваш день рождения 14 февраля — поздравляем: самый романтичный день рождения в году. В «Парусах» в этот день специальная программа: живая музыка, декор, особое меню. Скидка 20% именинникам — и на скидку День влюблённых. Двойной повод для особенного вечера.",
        "highlight": "14 февраля в «Парусах» — это когда романтика удвоена. Именинник + Валентинов день + вид на Петербург = вечер, о котором говорят потом."
      },
      {
        "heading": "Как организовать февральский праздник",
        "body": "Для 14-го — бронируйте за 2–3 недели, это очень загруженный день. Для других дат февраля — за 5–7 дней. Скажите о дне рождения при бронировании. Уточните о специальных предложениях месяца. +7 (812) 991-10-90, ул. Марата, 5.",
        "list": [
          "14 февраля: бронируйте за 2–3 недели",
          "Другие даты февраля: за 5–7 дней",
          "Скажите о дне рождения",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать февральский праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-45-let-restoran-peterburg",
    "title": "День рождения 45 лет в Петербурге: между зрелостью и мудростью",
    "metaTitle": "День рождения 45 лет в Петербурге — ресторан | Паруса на крыше",
    "metaDescription": "Где отметить 45-летие в Санкт-Петербурге: стильный ресторан с видом, живая музыка, банкетное меню. Скидка 20% именинникам.",
    "keywords": "день рождения 45 лет петербург, сорокапятилетие ресторан спб, юбилей 45 лет",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "45 лет — не юбилей в традиционном понимании, но значимая дата. Полюстадия жизни, когда уже есть что вспомнить и ещё многое впереди. Праздник должен отражать эту зрелость.",
    "sections": [
      {
        "heading": "45-летие: полные сил",
        "body": "В 45 лет не нужны ни детские развлечения, ни чрезмерная помпезность. Нужно хорошее место с умным сочетанием атмосферы и вкуса. «Паруса на крыше» — именно такое: стиль без претензий, кухня без снобизма, вид без пафоса. Гости этого возраста ценят именно это: всё сделано правильно, ничего лишнего.",
        "list": [
          "Стиль без претензий",
          "Авторская кухня с характером",
          "Панорамный вид на центр Петербурга",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что важно для 45-летия",
        "body": "Хорошая музыка (живая — обязательно), правильное вино (сомелье поможет), стол у окна, именинный торт от шефа и компания, которой не нужно объяснять, почему это место — хорошее. В «Парусах» рейтинг 5,0 и 2 606 отзывов. Приводят без объяснений — место говорит само.",
        "highlight": "45 лет в «Парусах» — это когда место не нужно оправдывать. Панорама Петербурга делает это сама."
      },
      {
        "heading": "Форматы и бронирование",
        "body": "Для 45-летия: камерный ужин 8–15 человек у окна или небольшой банкет 20–40 человек. Оба формата возможны. Бронируйте за 1–2 недели. +7 (812) 991-10-90.",
        "list": [
          "Камерный ужин: 8–15 человек",
          "Небольшой банкет: 20–40 человек",
          "Бронируйте за 1–2 недели",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать 45-летие", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-55-let-restoran-peterburg",
    "title": "День рождения 55 лет в Петербурге: достойный юбилей",
    "metaTitle": "День рождения 55 лет в Петербурге — юбилей | Паруса на крыше",
    "metaDescription": "Как отметить 55-летие в Санкт-Петербурге достойно: ресторан с видом, банкет. Скидка 20% именинникам. Банкетное меню от 2500 ₽/чел.",
    "keywords": "день рождения 55 лет петербург, пятьдесят пять лет ресторан спб, юбилей 55",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/view_day.webp",
    "lead": "55 лет — значимая дата. Полжизни позади, но не меньше впереди. Юбиляр в 55 знает, чего хочет, и заслуживает именно этого: достойного места и достойного праздника.",
    "sections": [
      {
        "heading": "55-летие в Петербурге",
        "body": "Пятьдесят пять — юбилей, который принято отмечать с родственниками и близкими. Компания обычно 25–60 человек. В «Парусах» для этого есть залы с видом на Петербург. Банкетный менеджер поможет с меню, рассадкой и программой. Живая музыка — включена в вечер с четверга по воскресенье.",
        "list": [
          "Залы на 25–120 гостей",
          "Панорамный вид на Петербург",
          "Живая музыка — включена",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Программа юбилея",
        "body": "Классическая программа: встреча с шампанским, торжественный ужин, поздравления, торт со свечами. Можно добавить: ведущего, видеопоздравления, слайд-шоу, романтический вокал. Банкетный менеджер ресторана помогает скоординировать всё.",
        "highlight": "55 лет — это много и одновременно не много. Юбилей должен быть тёплым и достойным. В «Парусах» это именно так: без помпезности, с настоящей заботой."
      },
      {
        "heading": "Бронирование",
        "body": "Звоните за 3–5 недель: +7 (812) 991-10-90. Скажите дату, количество гостей и что это 55-летие. Менеджер предложит оптимальный зал и формат. Банкетное меню от 2 500 ₽/чел.",
        "list": [
          "Бронируйте за 3–5 недель",
          "Скажите о 55-летии при бронировании",
          "Банкетное меню от 2 500 ₽/чел",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 55 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-65-let-otprazdnovat-spb",
    "title": "День рождения 65 лет в Петербурге: как организовать красиво",
    "metaTitle": "День рождения 65 лет в Петербурге | Паруса на крыше",
    "metaDescription": "Организация дня рождения 65 лет в Санкт-Петербурге: ресторан с комфортом и видом. Банкетное меню, живая музыка, скидка 20% именинникам.",
    "keywords": "день рождения 65 лет петербург, шестьдесят пять ресторан спб, юбилей 65",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "65 лет — это зрелость, накопленный опыт и право праздновать именно так, как хочется. Для многих — первый раз, когда дети организуют праздник для родителей. Это особенная ответственность и особенная радость.",
    "sections": [
      {
        "heading": "Юбилей 65 лет: что важно",
        "body": "На 65-летии часто дети организуют праздник для родителей. Им важно выбрать место, которое понравится именно юбиляру: комфортное, красивое, с хорошей кухней. «Паруса на крыше» справляются: уютные залы, доступная кухня для всех вкусов, живая музыка фоном, лифт в Olympic Plaza. Всё продумано.",
        "list": [
          "Доступность: лифт, удобный вход",
          "Кухня для всех вкусов",
          "Живая музыка — мягкий фон",
          "Дети организуют — родители наслаждаются"
        ]
      },
      {
        "heading": "Сюрприз или совместное планирование",
        "body": "Два подхода: организовать сюрприз или планировать вместе с юбиляром. Сюрприз — риск, что место не совпадёт с вкусом. Совместное планирование — юбиляр знает куда идёт, но всё равно рад. В «Парусах» оба формата работают: менеджер помогает организовать неожиданный вынос торта в любом сценарии.",
        "highlight": "Если организуете сюрприз — скажите менеджеру при бронировании. Команда «Парусов» умеет создать момент, который трогает."
      },
      {
        "heading": "Организация и детали",
        "body": "Для 65-летия: 20–50 гостей, отдельный зал, ужин с программой. Бронируйте за 3–4 недели. Банкетное меню от 2 500 ₽/чел. Скидка 20% именинникам. +7 (812) 991-10-90.",
        "list": [
          "20–50 гостей: оптимальный размер",
          "Бронируйте за 3–4 недели",
          "Банкетное меню от 2 500 ₽/чел",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать юбилей 65 лет", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "obedenny-prazdnik-dr-restoran-spb",
    "title": "Обеденный день рождения в ресторане Петербурга: дневной формат",
    "metaTitle": "Обеденный день рождения в ресторане СПб | Паруса на крыше",
    "metaDescription": "Отметить день рождения в обед в Петербурге: дневные виды, бизнес-ланч или банкет. Скидка 20% именинникам. Ул. Марата 5.",
    "keywords": "обедать день рождения ресторан спб, дневной праздник петербург, день рождения в обед",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/view_day.webp",
    "lead": "Не все хотят праздновать вечером. Дневной обед на день рождения — это свет, расслабленность и возможность закончить праздник до темноты. В Петербурге дневной вид с 6-го этажа тоже красив.",
    "sections": [
      {
        "heading": "Обеденный формат: когда это удобно",
        "body": "Обеденный праздник идеален для: семей с маленькими детьми (вечером сложнее), пожилых родственников (вечер тяжелее), рабочего дня (праздник в обед, вечером свободны). В «Парусах» бизнес-ланч от 590 ₽ — это лучшая ценность для обеда. Для праздника можно заказать полный обед по меню: более торжественно, без спешки.",
        "list": [
          "Удобно для семей с детьми",
          "Хорошо для пожилых гостей",
          "Бизнес-ланч от 590 ₽",
          "Обед по меню — для праздника"
        ]
      },
      {
        "heading": "Дневной вид на Петербург",
        "body": "Дневной Петербург с 6-го этажа — совсем другой, чем ночной. Ясный свет, детали архитектуры, купола в полуденном золоте. Если погода хорошая — открытый горизонт над крышами. Обеденный праздник с таким видом — неочевидный, но прекрасный выбор.",
        "highlight": "Обед в «Парусах» в ясный день — это когда видно Исаакий, Казанский и дальше до залива. Погода Петербурга непредсказуема, но когда совпадает — это запоминается."
      },
      {
        "heading": "Как организовать",
        "body": "Позвоните за 1–3 дня: +7 (812) 991-10-90. Скажите «день рождения в обед, [количество гостей]». Уточните: хотите ли торт или достаточно десерта из меню. Скидка 20% именинникам — работает и в обед.",
        "list": [
          "Бронируйте за 1–3 дня для обеда",
          "Скидка 20% работает и в обед",
          "Торт под заказ или десерт из меню",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать обеденный праздник", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-15-chelovek-restoran-peterburg",
    "title": "День рождения на 15 человек в Петербурге: правильный масштаб",
    "metaTitle": "День рождения на 15 человек в ресторане СПб | Паруса на крыше",
    "metaDescription": "День рождения на 15 человек в Петербурге: стол у окна или небольшой зал. Банкетное меню, живая музыка. Скидка 20% именинникам.",
    "keywords": "день рождения 15 человек ресторан спб, праздник пятнадцать человек, банкет 15 гостей петербург",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 5,
    "image": "/photos/interior.webp",
    "lead": "15 человек — золотое число. Достаточно для весёлой компании, достаточно мало, чтобы каждый гость мог сказать тост и все слышали. Именно этот размер чаще всего называют идеальным для дня рождения.",
    "sections": [
      {
        "heading": "Почему 15 — идеальное число",
        "body": "15 гостей — это граница между «посидели небольшой компанией» и «провели настоящий праздник». Всё работает: и живые разговоры, и общие тосты, и один большой торт на всех. В «Парусах» для 15 человек отлично подходит большой стол у панорамных окон или небольшой отдельный зал.",
        "list": [
          "Большой стол у окна — для 15 гостей",
          "Или небольшой отдельный зал",
          "Все слышат друг друга",
          "Скидка 20% именинникам"
        ]
      },
      {
        "heading": "Что заказать на 15 человек",
        "body": "Для 15 гостей хорошо работает банкетное меню от 2 500 ₽/чел: всё включено, нет путаницы с заказом, еда приходит одновременно. Можно и à la carte — но с менеджером согласуйте заранее, чтобы не было задержек. Торт на 15 человек: хватает стандартного 2 кг.",
        "highlight": "15 гостей в «Парусах» — это тот формат, где всё работает само. Место, музыка, еда — вам остаётся только принимать поздравления."
      },
      {
        "heading": "Практические детали",
        "body": "Бронируйте за 1–2 недели. Скажите «15 человек, день рождения». Уточните: хотите банкетное меню или à la carte. Скидка 20% на счёт именинника. +7 (812) 991-10-90.",
        "list": [
          "Бронируйте за 1–2 недели",
          "Банкетное меню от 2 500 ₽/чел",
          "Торт на 15 гостей: ~2 кг",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать на 15 человек", "href": "/den-rozhdeniya" }
  },
  {
    "slug": "den-rozhdeniya-40-chelovek-restoran-peterburg",
    "title": "День рождения на 40 человек в Петербурге: организация банкета",
    "metaTitle": "День рождения на 40 человек — банкет СПб | Паруса на крыше",
    "metaDescription": "Как организовать день рождения на 40 человек в Санкт-Петербурге. Банкетный зал, живая музыка, меню от 2500 ₽/чел. Скидка 20% именинникам.",
    "keywords": "день рождения 40 человек ресторан спб, банкет 40 гостей петербург, праздник сорок человек",
    "date": "2026-06-19",
    "category": "День рождения в Петербурге",
    "readTime": 6,
    "image": "/photos/interior.webp",
    "lead": "40 гостей — это уже серьёзный банкет. Нужен отдельный зал, продуманная рассадка, чёткая подача блюд. Хорошо, что в «Парусах» это стандартный формат.",
    "sections": [
      {
        "heading": "Организация банкета на 40 человек",
        "body": "Для 40 гостей нужен отдельный зал. В «Парусах» есть залы именно этого размера с панорамным видом на Петербург. Рассадка: можно один большой стол-«подкову», несколько столов по 8–10, или ресторанный формат по 4–6. Всё зависит от характера праздника.",
        "list": [
          "Отдельный зал с видом",
          "Разные варианты рассадки",
          "Банкетное меню от 2 500 ₽/чел",
          "Живая музыка включена"
        ]
      },
      {
        "heading": "Программа вечера",
        "body": "Стандартная программа для 40 гостей: встреча (20 мин), ужин (1,5–2 ч), поздравления и тосты (30–40 мин), торт и финальная часть (30 мин). Итого 3–3,5 часа. Если нужен ведущий — предусмотрите это при бронировании. Скидка 20% на счёт именинника, десерт в подарок.",
        "highlight": "40 гостей: достаточно для веселья, достаточно мало для того, чтобы именинник лично поговорил с каждым. Это хороший баланс."
      },
      {
        "heading": "Бронирование и бюджет",
        "body": "Банкет на 40: от 2 500 ₽/чел × 40 = от 100 000 ₽. Алкоголь — отдельно. Бронируйте за 2–3 недели. +7 (812) 991-10-90.",
        "list": [
          "От 100 000 ₽ без алкоголя",
          "Алкоголь по карте или пакет",
          "Бронируйте за 2–3 недели",
          "+7 (812) 991-10-90"
        ]
      }
    ],
    "cta": { "text": "Забронировать банкет на 40", "href": "/banket" }
  }
];
